/* Built In Imports */

/* External Imports */
import { Box, Link, Modal, ModalBody, ModalContent, ModalHeader, ModalCloseButton, ModalOverlay, useDisclosure } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
import MidContainer from '@Layout/MidContainer';
import ContentArea from '@components/Layout/ContentArea';
import SectionTitle from '@components/Headings/SectionTitle';
import SingleImage from '@components/Card/SingleImage';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import { refineUrlDomain } from '@components/Utility/utils';
import TopKolam from '@ihs/components/Headings/TopKolam';
import MediaEmbed from '@components/Embeds/MediaEmbed';
/* Components */
/* Services */

/* Styles */

/**
 * Renders the About Container component
 *
 *
 * @returns {ReactElement} About Container component
 */
const PopupWindow = ({section, region, lang}) => {
  const sectionContent = section?.sectionContent;
  // console.log('data',sectionContent);
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
  <>
    <Box>
    <TopKolam sectionContent={sectionContent[0]} />
      <SectionTitle
            titleObj={sectionContent[1]}
            style={{
              fontStyle: 'italic',
              fontWeight: '400 !important',
              fontSize: '35px',
              lineHeight: '116%',
              fontFamily:'FedraSansStd-book',
            }}
          />
        <SingleImage
            sectionContent={sectionContent[2]}
            region={region}
            lang={lang}
          />
    </Box>
    <MidContainer>
        <Box className='event_description' fontFamily="FedraSansStd-book" lineHeight="2" m="20px auto" maxW={{ base:'90%', md:'770px'}}>
          <ContentArea
            mainContent={sectionContent[3].body}
            tAlign={sectionContent.style}
            region={region}
            lang={lang}
            pb="0px"
          />
        <Box as="p" fontFamily="FedraSansStd-A-medium" p="10px 17px !important">{sectionContent[3]?.text} <Link onClick={onOpen}>{sectionContent[4]?.text}</Link></Box>
        </Box>
    </MidContainer>
    <MediaEmbed sectionContent={sectionContent[4]} />
    <Modal
        isOpen={isOpen} onClose={onClose}
        closeOnOverlayClick={false}
        isCentered
        size="4xl"
        blockScrollOnMount={true}
        p="0"
        w={{ base: "95%", md: "auto" }}
        height={{ base: "auto" }}
        >
        <ModalOverlay />
        <ModalContent>
            <ModalHeader
            paddingBottom="0"
            fontFamily="FedraSansStd-A-medium"
            >
            <Box><SectionTitle titleObj={sectionContent[7]} mt="0px" /></Box>
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody
            fontFamily="FedraSansStd-medium"
            fontSize="16px"
            display="block"
            paddingTop="0px"
            >
            <Box
                width="auto"
                marginTop="0px"
                height={{base:'280px', md:'180px'}}
                color="#7a7a7a"
                fontFamily="FedraSansStd-book"
            >
                <StructuredTextParser
                str={render(sectionContent[8]?.body)}
                region={region}
                lang={lang}
                fontSize="16px"
                color="#000000"
                fontFamily="FedraSansStd-book"
                className="popuptext"
                />
            </Box>
            <Box marginTop="20px">
                <Box as="div" marginTop="30px" textAlign="center">
                <Link
                    target="_blank"
                    href={refineUrlDomain(
                      sectionContent[9]?.linkUrl,
                      region,
                      lang
                    )}
                    display="inline-block"
                    mb="20px"
                    fontFamily="FedraSansStd-medium"
                    borderRadius="3px"
                    bgColor="#cf4520"
                    color="rgb(250 247 240)"
                    fontSize="16px"
                    padding="10px 35px"
                    _hover={{
                    textDecoration: 'none',
                    }}
                >
                    {sectionContent[9]?.buttonText}
                </Link>
                </Box>
            </Box>
            </ModalBody>
        </ModalContent>
        <style jsx global>
        {`
          .linkText p a {
            text-decoration: underline;
          }
          .popuptext p {
            line-height: 25px;
            padding: 5px 0;
          }
          .event_description p {
            line-height: 1.7;
            font-size: 16px;
            padding: 4px 10px;
          }
        `}
      </style>
    </Modal>
  </>
  );
};

export default PopupWindow;
